import React from 'react';
import { AuthContext } from '../../context/auth/ApiContext';

const Index = () => {
    const { logOut } = React.useContext(AuthContext);

    React.useEffect(() => {
        logOut();
    }, []);


    return (
        <div>

        </div>
    );
};

export default Index;